var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCollapseWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_102_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.41667 10C0.41667 15.2927 4.70727 19.5833 10 19.5833C15.2927 19.5833 19.5833 15.2927 19.5833 10C19.5833 4.70727 15.2927 0.416662 10 0.416662C4.70727 0.416662 0.41667 4.70727 0.41667 10Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.41667 10C0.41667 15.2927 4.70727 19.5833 10 19.5833C15.2927 19.5833 19.5833 15.2927 19.5833 10C19.5833 4.70727 15.2927 0.416662 10 0.416662C4.70727 0.416662 0.41667 4.70727 0.41667 10Z",
    stroke: "#EDEDED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.03822 6.12789C7.9995 6.08918 7.96879 6.04322 7.94784 5.99264C7.92689 5.94206 7.91611 5.88785 7.91611 5.8331C7.91611 5.77835 7.92689 5.72414 7.94784 5.67356C7.96879 5.62298 7.9995 5.57702 8.03822 5.53831C8.07692 5.4996 8.12288 5.46889 8.17347 5.44793C8.22405 5.42698 8.27826 5.4162 8.33301 5.4162C8.38775 5.4162 8.442 5.42698 8.49258 5.44793C8.54317 5.46889 8.58908 5.4996 8.62783 5.53831L12.7945 9.705C12.8332 9.74367 12.8639 9.78967 12.8849 9.84025C12.9058 9.89083 12.9167 9.945 12.9167 9.99975C12.9167 10.0545 12.9058 10.1087 12.8849 10.1593C12.8639 10.2099 12.8332 10.2558 12.7945 10.2946L8.62783 14.4612C8.54958 14.5394 8.44358 14.5833 8.33301 14.5833C8.22243 14.5833 8.1164 14.5394 8.03822 14.4612C7.96003 14.3831 7.91611 14.277 7.91611 14.1664C7.91611 14.0558 7.96003 13.9498 8.03822 13.8717L11.9106 9.99975L8.03822 6.12789Z",
    fill: "#2A2B28"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_102_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollapseWhite);
export default __webpack_public_path__ + "static/media/collapse-white.4c4d501b65b68b7a94bbaf00ddf9e5f4.svg";
export { ForwardRef as ReactComponent };